export default {
  validate(email, t) {
    var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (t) {
      if (!email.match(EMAIL_REGEXP)) {
        return t('invalid_email');
      }
      return true;
    } else {
      return email.match(EMAIL_REGEXP);
    }
  }
}


// WEBPACK FOOTER //
// ./src/emailvalidation.js